export default __webpack_public_path__ + "static/media/Playing Danndiya_2056.9cdd1e90.png";